import { useEffect, useRef, useState } from 'react';
import { Search } from 'lucide-react';

export function SearchInput({ value, onChange, placeholder = 'Buscar...', className = '' }) {
  const [v, setV] = useState(value ?? '');
  const ref = useRef();

  useEffect(() => {
    setV(value ?? '');
  }, [value]);

  return (
    <div className={`relative ${className}`}>
      <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted pointer-events-none" />
      <input
        ref={ref}
        type="text"
        value={v}
        onChange={(e) => { setV(e.target.value); onChange?.(e.target.value); }}
        placeholder={placeholder}
        className="w-full pl-9 pr-3 py-2 bg-panel-2 border border-border rounded-md text-sm text-white placeholder-muted focus:outline-none focus:border-cyan-500"
      />
    </div>
  );
}
